import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import TopNavBar from '../Layout/TopNavBar';
import BackNavigation from '../Common/BackNavigation';
import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import upload from "../../assets/upload.svg";
import MinusAdjustment from "../../assets/max-adjustment.svg";
import addplus from "../../assets/addplusicon.png";
import { title } from 'process';
import { showAlert, showError, showSuccess } from '../utills/sweetAlert';
import { callApi } from '../utills/api';

type Row = {
    attachment: any[];  // Updated to `any[]` if you want attachment to be an array that can hold any type
    updateStatus: boolean;
    errorMessage?: string;
};

const CareersDetails: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { masterId } = location.state || {};
    const [siteDetails, setsiteDetails] = useState<any[]>([]);

    useEffect(() => {
        console.log("coming");

        if (masterId) {
            getEditSelect();
        }
    }, []);

    const getEditSelect = () => {
        console.log("coming");

        let req = {
            id: masterId,
        };
        callApi("POST", "careersSingleselect.php", req)
            .then((res) => res.data)
            .then((response) => {
                console.log("coming");
                
                if (response && response.data) {
                    const parsedData = response.data.map((item: any) => ({
                        ...item,
                        careers_details: JSON.parse(item.careers_details) 
                    }));
                    console.log("parsedData--->", parsedData);
                    setsiteDetails(parsedData);
                    console.log("siteDetails--->", siteDetails);
                } else {
                    console.warn("No image data found in the response");
                    setsiteDetails([]); 
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    };

    

    return (
        <>
            <div className="mobile_nav_bar">
                <TopNavBar />
            </div>
            <div className='mblcontent'>
                <Row className='webview'>
                    <div className="category-header">
                        <Col lg="9" md="9">
                            <BackNavigation />
                            <h3 className="category-title mt-2">
                                {masterId ? "Careers Details" : "Careers Details"}
                            </h3>
                        </Col>
                    </div>
                </Row>
                {siteDetails.map((item, index) => (
                <div className="careerscontainer">
                    
                    <Row>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Information</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} className="mb-3">
                                   
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Post Applied for
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                            <h6>{item.careers_details.postappliedfor}</h6>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Subject Preference 1
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.subjectpref1}</h6>

                                        </Col>
                                    </Row>
                                    
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Subject Preference 2
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.subjectpref2}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Curriculum
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.curriculum}</h6>

                                        </Col>
                                    </Row>
                                  
                                </Col>
                            </Row>
                        </div>
                        <br />

                    </Row>
                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Personal Information</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} className="mb-3">
                                    
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Name of the  Applicant
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.namesalutation} {item.careers_details.firstname}</h6>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Date of Birth
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.dob} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Place of Birth
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.pob} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Birth State
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.birthstate} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Gender
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.gender} </h6>

                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>AADHAR No
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.aadharno} </h6>

                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>PAN No
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.panno} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                             
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Nationality
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.nationality} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Religion
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.religion} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Community
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.category} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Blood Group
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.bloodgroup} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Marital Status
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.maritalstatus} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>
                    {/* //Personal Information section code// */}
                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Contact Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} className="mb-3">
                                    
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Address
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.praddress} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>City
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.city} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>State
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.state} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Mobile No
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.mobileno} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Telephone No / Alternative
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.mobileno2} </h6>

                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Email ID 
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.emailid} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Name & Occupation Parents</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} className="mb-3">
                                    
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Father Name
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.fname} </h6>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Father Occupation
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.foccupation} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Mother Name
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.mname} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Mother Occupation
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.moccupation} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>


                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Spouse Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} className="mb-3">
                                    
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Spouse Name
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.spousename} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Spouse Qualification
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.spousequalification} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Spouse Profession
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.spouseprofession} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Is spouse's job transferable
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.spousejobtransferrable} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Spouse Organization
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.spouseorganization} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Spouse Designation
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.spousedesignation} </h6>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Children Information</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12} className="mb-3">
                                    
                                <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Name</th>
                                        <th>Gender</th>
                                        <th>Age in Years</th>
                                    </tr>
                                </thead>
                                <tbody>

                                {item && item.careers_details?.children?.map((item: any, index: any) => (
                                        <tr key={item.id} style={{background:"#ffffff"}}>
                                            <td>
                                                {index + 1}
                                            </td>
                                            <td className='boldtd'>{item.name}</td>
                                            <td className=''>{item.gender}</td>
                                            <td className=''>{item.age}</td>
                                        
                                         
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                           
                        </div>
                                  </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Academic / Professional Qualifications</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} className="mb-3">
                                    
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Highest Qualifiaction in Subject Applied as Perference-1
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.highestqualification}</h6>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>B.ED
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.bedstudied}</h6>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Academic / Professional Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12} className="mb-3">
                                    
                                <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Qualification</th>
                                        <th>Main Subject</th>
                                        <th>School / Collage</th>
                                        <th>Board / University</th>
                                        <th>Year Of Passing</th>
                                        <th>%age of Marks</th>
                                        <th>Division</th>

                                    </tr>
                                </thead>
                                <tbody>
                                {item && item?.careers_details?.qualifications?.map((item:any, index:any) => (
                                        <tr key={item.id} style={{background:"#ffffff"}}>
                                            <td>
                                                {item.qualification_name}
                                            </td>
                                            <td className=''>{item.qualification_subjects}</td>
                                            <td className=''>{item.qualification_institute}</td>
                                            <td className=''>{item.qualification_university}</td>
                                            <td className=''>{item.qualification_passingyear}</td>
                                            <td className=''>{item.qualification_percentage}</td>
                                            <td className=''>{item.qualification_division}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                           
                        </div>
                                  </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Work Experience Applicable</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12} className="mb-3">
                                    
                                <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Name of Organisation</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Subject taught (if teacher)</th>
                                        <th>Class taught (if teacher)</th>
                                        <th>Other Responsibilities</th>

                                    </tr>
                                </thead>
                                 <tbody>
                                {item && item?.careers_details?.organisations?.map((item:any, index:any) => (
                                        <tr key={item.id} style={{background:"#ffffff"}}>
                                           
                                            <td className=''>{item.organisation_name}</td>
                                            <td className=''>{item.experience_from}</td>
                                            <td className=''>{item.experience_to}</td>
                                            <td className=''>{item.experience_subjects}</td>
                                            <td className=''>{item.experience_class}</td>
                                            <td className=''>{item.experience_other}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                           
                        </div>
                                  </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Note: (From latest to oldest)</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12} className="mb-3">
                                    
                                <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>In Completed Years</th>
                                        <th>Teaching</th>
                                        <th>Administration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr key={item.id} style={{background:"#ffffff"}}>
                                            <td>
                                               Total Experience
                                            </td>
                                       <td>
                                       <h6>{item.careers_details.experienceyears}</h6>
                                       </td>
                                       <td>
                                       <h6>{item.careers_details.experienceyearsteaching}</h6>
                                       </td> <td>
                                       <h6>{item.careers_details.experienceyearsadmin}</h6>
                                       </td>
                                           
                                        </tr>
                                </tbody>
                            </table>
                           
                        </div>
                                  </Col>

                                  <Col lg={6} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Any Other (please specify)
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.experienceothers}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>


                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Previous Job Information</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} className="mb-3">
                                    
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Name of  Institution
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitution}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Address
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutionaddress}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                     
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Contact Number
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutioncontact}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Previous / Present Designation
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutiondesignation}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Date of joining
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutiondoj}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Place of Posting
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutionpostingplace}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Total emoluments
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutionemoluments}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Basic
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutionbasic}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Allowance
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutionallowance}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Other Benefits
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutionotherbenefits}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Last Salery Drawn
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.lastsalarydrawn}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Were you under service bond
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.previnstitutionservicebond}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Proficiency in Languages & Computers</h5>
                                    
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12} className="mb-3">
                                    
                                <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Language</th>
                                        <th>Speak</th>
                                        <th>Read</th>
                                        <th>Write</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {item && item?.careers_details?.languages?.map((item:any, index:any) => (
                                        <tr key={item.id} style={{background:"#ffffff"}}>
                                            <td>
                                                {item.language_name}
                                            </td>
                                            <td className=''>{item.speak}</td>
                                            <td className=''>{item.read}</td>
                                            <td className=''>{item.write}</td>
                                           
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                           
                        </div>
                                  </Col>
                                  <Col lg={6} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Any other Language/s known
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.otherlanguage}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Proficiency in Computer
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.computerproficiency}</h6>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                {/* <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Proficiency in Languages & Computers</h5>
                                    
                                </Col> */}
                            </Row>
                            <Row>
                               
                                  <Col lg={12} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Expected Monthly Salary
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.expectedmonthlysalary}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Is any member of your family employed in any SSVM Institutions?
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.familymember}</h6>

                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={12} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Name
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.familymembername}</h6>

                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={12} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Relationship
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.familymemberrelationship}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} className="mb-3">
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Label className='labelforcareers'>Institution Name
                                            </Form.Label>
                                        </Col>
                                        <Col lg={1} className='labelforcareers'>
                                            :
                                        </Col>
                                        <Col lg={5}>
                                        <h6>{item.careers_details.familymemberinstitution}</h6>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>


                    <Row className='mt-4'>
                        <div className="information-section">
                            <Row className="mb-4">
                                <Col lg={12} className="info-header">
                                    <h5 className="text-white p-2" style={{ backgroundColor: '#cfe2f3' }}>Resume & Profile Image & Sign Image</h5>
                                    
                                </Col>
                            </Row>
                            <Row>
                               
                                  <Col lg={12} className="mb-3">
                                  <h6 className='labelforcareers'>Resume :</h6>
                                  <a href={`https://kgischool.edu.in/api/uploads/${item.careers_details.file_resume}`} target="_blank"> Preview Resume PDF</a>
                                </Col>
                                <Col lg={12} className="mb-3">
                                   <h6 className='labelforcareers'>Profile picture :</h6>
                                   <img
                                               src={`https://kgischool.edu.in/api/uploads/${item.careers_details.file_passport}`}
                                                alt="Profile picture"
                                                style={{ width: "300px", height:"300px" }}
                                            />
                                </Col>

                                <Col lg={12} className="mb-3">

                                <h6 className='labelforcareers'>Signature picture :</h6>
                                   <img
                                               src={`https://kgischool.edu.in/api/uploads/${item.careers_details.file_sign}`}
                                                alt="Profile picture"
                                                style={{ width: "300px", height:"300px" }}
                                            />
                                </Col>
                            </Row>
                        </div>
                        <br />
                    </Row>

                </div>
            ))}
            </div>
        </>
    );
};
export default CareersDetails;